import {
  GET_BOARD_WHITE_SPACES,
  GET_WHITE_SPACE_BY_ID,
  CREATE_WHITE_SPACE,
  UPDATE_WHITE_SPACE,
  SET_WHITE_SPACE_ARCHIVE,
  DELETE_WHITE_SPACE,
  CREATE_TASK_WHITE_SPACE,
  CREATE_TASK_MAP_WHITE_SPACE,
  UPDATE_TASK_WHITE_SPACE,
  UPDATE_TASK_MAP_WHITE_SPACE,
  DELETE_TASK_WHITE_SPACE,
  DELETE_TASK_MAP_WHITE_SPACE,
  SET_WHITE_SPACES_LOADING,
  SET_WHITE_SPACES_ERROR,
  CLEAR_WHITE_SPACE_STATE,
  CLEAR_CURRENT_WHITE_SPACE,
  GET_WHITE_SPACE_CATEGORIES,
  SET_WHITE_SPACE_CATEGORIES_LOADING,
  SET_WHITE_SPACE_CATEGORIES_ERROR,
} from "./WhiteSpaceType";

const INITIAL_STATE = {
  items: [],
  tasksItems: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    pages: 0,
  },
  currentWhiteSpace: null,
  loading: false,
  error: null,
  categories: [],
  categoriesLoading: false,
  categoriesError: null,
};

const updateWhiteSpaceInList = (items, updatedItem) => {
  const index = items.findIndex((item) => item._id === updatedItem._id);
  if (index === -1) return items;
  const next = [...items];
  next[index] = updatedItem;
  return next;
};

const removeWhiteSpaceFromList = (items, whiteSpaceId) =>
  items.filter((item) => item._id !== whiteSpaceId);

export const WhiteSpaceReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_WHITE_SPACES_LOADING:
      return {
        ...state,
        loading: action.Payload,
      };

    case SET_WHITE_SPACES_ERROR:
      return {
        ...state,
        error: action.Payload,
        loading: false,
      };

    case GET_BOARD_WHITE_SPACES:
      return {
        ...state,
        items: action.Payload.items ?? state.items,
        tasksItems: action.Payload.tasksItems ?? state.tasksItems,
        pagination: action.Payload.pagination ?? state.pagination,
        error: null,
      };

    case CREATE_TASK_WHITE_SPACE: {
      const { TaskID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID != null,
      );
      const withTaskId = items.map((i) => ({ ...i, TaskID }));
      return { ...state, tasksItems: [...rest, ...withTaskId], error: null };
    }
    case CREATE_TASK_MAP_WHITE_SPACE: {
      const { TaskID, TaskMapID, items } = action.Payload || {};
      if (!items || !Array.isArray(items)) return state;
      const rest = (state.tasksItems || []).filter(
        (t) => t.TaskID !== TaskID || t.TaskMapID !== TaskMapID,
      );
      const withIds = items.map((i) => ({ ...i, TaskID, TaskMapID }));
      return { ...state, tasksItems: [...rest, ...withIds], error: null };
    }
    case UPDATE_TASK_WHITE_SPACE:
    case UPDATE_TASK_MAP_WHITE_SPACE: {
      const items = action.Payload?.items;
      const whiteSpaceId = action.Payload?.WhiteSpaceID;
      if (!items || !Array.isArray(state.tasksItems) || !whiteSpaceId)
        return state;
      const updated = Array.isArray(items)
        ? items.find((x) => x._id === whiteSpaceId)
        : null;
      const next = state.tasksItems.map((t) =>
        t._id === whiteSpaceId ? { ...t, ...updated } : t,
      );
      return { ...state, tasksItems: next, error: null };
    }
    case DELETE_TASK_WHITE_SPACE:
    case DELETE_TASK_MAP_WHITE_SPACE:
      return {
        ...state,
        tasksItems: (state.tasksItems || []).filter(
          (t) => t._id !== action.Payload?.WhiteSpaceID,
        ),
        error: null,
      };

    case GET_WHITE_SPACE_BY_ID:
      return {
        ...state,
        currentWhiteSpace: action.Payload,
        error: null,
      };

    case CREATE_WHITE_SPACE:
      return {
        ...state,
        items: [action.Payload, ...state.items],
        currentWhiteSpace: action.Payload,
        pagination: {
          ...state.pagination,
          total: state.pagination.total + 1,
        },
        error: null,
      };

    case UPDATE_WHITE_SPACE:
      return {
        ...state,
        items: updateWhiteSpaceInList(state.items, action.Payload),
        currentWhiteSpace:
          state.currentWhiteSpace?._id === action.Payload._id
            ? action.Payload
            : state.currentWhiteSpace,
        error: null,
      };

    case SET_WHITE_SPACE_ARCHIVE:
      return {
        ...state,
        items: updateWhiteSpaceInList(state.items, action.Payload),
        currentWhiteSpace:
          state.currentWhiteSpace?._id === action.Payload._id
            ? action.Payload
            : state.currentWhiteSpace,
        error: null,
      };

    case DELETE_WHITE_SPACE:
      return {
        ...state,
        items: removeWhiteSpaceFromList(state.items, action.Payload),
        currentWhiteSpace:
          state.currentWhiteSpace?._id === action.Payload
            ? null
            : state.currentWhiteSpace,
        pagination: {
          ...state.pagination,
          total: Math.max(0, state.pagination.total - 1),
        },
        error: null,
      };

    case CLEAR_WHITE_SPACE_STATE:
      return INITIAL_STATE;

    case CLEAR_CURRENT_WHITE_SPACE:
      return {
        ...state,
        currentWhiteSpace: null,
      };

    case SET_WHITE_SPACE_CATEGORIES_LOADING:
      return {
        ...state,
        categoriesLoading: action.Payload,
      };

    case SET_WHITE_SPACE_CATEGORIES_ERROR:
      return {
        ...state,
        categoriesError: action.Payload,
        categoriesLoading: false,
      };

    case GET_WHITE_SPACE_CATEGORIES:
      return {
        ...state,
        categories: Array.isArray(action.Payload) ? action.Payload : [],
        categoriesError: null,
        categoriesLoading: false,
      };

    default:
      return state;
  }
};
